.consent {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}

.scroll {
  flex: 1;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: var(--space-24) var(--space-20) var(--space-16);
}

.title {
  margin: var(--space-16) 0 var(--space-8);
  font-size: 20px;
  font-weight: 650;
  line-height: 1.25;
  letter-spacing: -0.01em;
  text-wrap: balance;
}

.intro {
  margin: 0 0 var(--space-16);
  color: var(--w-muted);
  text-wrap: pretty;
}

.summary {
  display: grid;
  gap: var(--space-8);
  margin: 0 0 var(--space-20);
  padding: 0;
  list-style: none;
}

.summary li {
  display: flex;
  gap: var(--space-8);
  align-items: flex-start;
}

.check {
  width: 16px;
  height: 16px;
  margin-top: 3px;
  color: var(--w-accent-text);
}

.details {
  border-top: 1px solid var(--w-border);
  padding-top: var(--space-12);
  color: var(--w-muted);
  font-size: 14px;
}

.details summary {
  color: var(--w-text);
  font-weight: 550;
  cursor: pointer;
}

.details h3 {
  margin: var(--space-16) 0 var(--space-4);
  color: var(--w-text);
  font-size: 14px;
  font-weight: 600;
}

.details p {
  margin: 0;
  text-wrap: pretty;
}

.footer {
  flex: none;
  padding: var(--space-12) var(--space-16) max(var(--space-16), var(--safe-bottom));
  border-top: 1px solid var(--w-border);
}

.accept {
  width: 100%;
  min-height: 48px;
  border: 0;
  border-radius: 14px;
  background: var(--w-accent);
  color: var(--w-on-accent);
  font-weight: 600;
  cursor: pointer;
  transition: transform 120ms var(--ease-out), background-color 160ms ease;
}

.accept:active {
  transform: scale(0.98);
}

@media (hover: hover) and (pointer: fine) {
  .accept:hover {
    background: var(--w-accent-strong);
  }
}
